export const getDiscountPercent = (discount, compareAtPrice) =>
  discount && compareAtPrice ? (+discount / +compareAtPrice).toFixed(2) * 100 : null;
